const BOOT_FLAG_KEY = 'rl_admin_stock_app_bootstrapped';

// sessionStorage can throw in private-browsing/disabled-storage contexts.
export const hasBootstrappedBefore = () => {
  try {
    return sessionStorage.getItem(BOOT_FLAG_KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const markBootstrapped = () => {
  try {
    sessionStorage.setItem(BOOT_FLAG_KEY, '1');
  } catch (e) {
    /* ignore */
  }
};

export const clearBootstrapFlag = () => {
  try {
    sessionStorage.removeItem(BOOT_FLAG_KEY);
  } catch (e) {
    /* ignore */
  }
};
